import { sessionCookieOptions } from 'lib/session.service';

export const getAuthProviderSessionCookie = () => {
  if (window.location.origin.includes(process.env.NEXT_PUBLIC_CP_DOMAIN || '')
    && process.env.NODE_ENV === 'production') {
    return { ...sessionCookieOptions, domain: process.env.NEXT_PUBLIC_CP_DOMAIN };
  }

  return sessionCookieOptions;
};
